<script>
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

/**
 * Consulta de documentos.
 */
export default {
  components: { Layout, PageHeader, Multiselect,DatePicker, },
  page: {
    title: 'Consulta de Documentos',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {     
      title: 'Consulta de Documentos.',     
      archivoDesc:[
        {key:'idArchivo',soportable:false, label:""},
        {key:'idDocumento', soportable:false, label:""},
        {key:'file', soportable:false, label:""},
        {key:'nombre', soportable:false, label:"Nombre del Archivo"}
      ],
      listaDocumentos:[],
        fields: [
        { key: 'folio', sortable: false,label:"Folio" },
        { key: 'nombre', sortable: false,  label:"Documento" },
        { key: 'tipoDocumento', sortable: false,  label:"Tipo Documento" },
        { key: 'organismo', sortable: false,  label:"Organismo" },
        { key: 'fecha', sortable: false,  label:"Fecha" },
        { key: 'status', sortable: false,  label:"Estado" },
        { key: 'idDocumento', sortable: false,  label:"" },
      ],
      requestComboOrganismos :{
        perPage : 100,
        cuerrentPage :0,
        filter: ""
      },
      requestComboTipoDocumentos :{
        perPage : 100,
        cuerrentPage :0,
        filter: ""
      },
      filter: null,
      filterOn: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      totalRows: 0,
      isBusy: false,
      isLoadingCombo : false,
      isLoadingComboTipoDocumentos: false,
      listadoTipoDocumentos: [],
      listadoOrganismos:[],
      listaValoresMetadatos:[],
      organismoSeleccionado : null ,
      tipoDocumentoSeleccion : null,
      nombreDocumento:'',
      valoresSeleccionado : [],
      items: [
        {
          text: 'REPODECAM',
          href: '/',
        },
        {
          text: 'Documentos',
          href: '/documentos',
        },
        {
          text: 'Consulta',
          active: true,
        },
      ]     
    }
  },  
  computed:{
  
  },
  mounted(){
    this.loadOrganismos();
    this.loadTiposDocumentos();
  },
  methods:{
    cargarListado(){
       this.isBusy = true;
       var contexto = {
         perPage : this.perPage,
         currentPage : this.currentPage,
         idOrganismo : "",
         idTipoDocumento :"",
         nombreDocumento :this.nombreDocumento,
         valores:[]
       };

       if(this.organismoSeleccionado != null){
         contexto.idOrganismo = this.organismoSeleccionado.id
       }
       if(this.tipoDocumentoSeleccion != null){
         contexto.idTipoDocumento = this.tipoDocumentoSeleccion.id
       }

        this.listaValoresMetadatos.forEach(function (key, value) {

          var valorSeleccionado = ""
          if (key.valor) {
              if (key.tipo === "Fecha") {
               valorSeleccionado = moment(key.valor).format('DD/MM/YY');
            } else if (key.tipo === "Lista") {
                valorSeleccionado =  key.valor.valor;
            } else {
                valorSeleccionado = key.valor;
            }
          contexto.valores.push(
            {
              idMetadato:key.idMetadato,
              valor:valorSeleccionado

            }
          ); 
            
          }
           
        });
       axios
            .post(appConfig.recursosApi.documento + "/listado",contexto)      
            .then((response) => {
                this.listaDocumentos= response.data;               
                this.isBusy = false;                
            })
             .catch(()=>  {
               this.isBusy = false;               
                this.$router.push('/500') ;                
            }); 
     },
    tipoDocumentoSeleccionado(value){
           axios
            .get(appConfig.recursosApi.tipoDocumento + "/metadato/" + value.id)
            .then((response) => {
                this.listaValoresMetadatos = response.data;
            })
             .catch(()=>  {
               this.listaValoresMetadatos = [];                           
                this.$router.push('/500') ;                
            }); 
    },
    handleFileUpload(e){        
         this.form.archivo = this.$refs.fileDocumento.files[0];
      },
    loadOrganismos(query=""){
        this.isLoadingCombo = true;
        this.requestComboOrganismos.filter = query;
        axios
            .get(appConfig.recursosApi.organismo,{params: this.requestComboOrganismos  })
            .then((response) => {
                this.listadoOrganismos = response.data.result;                
                this.isLoadingCombo = false;
                return this.data
            })
             .catch(()=>  {
               this.listadoOrganismos = [];
               this.isLoadingCombo = false;
               // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                this.$router.push('/500') ;                
            }); 
    },
    loadTiposDocumentos(query=""){
        this.isLoadingComboTipoDocumentos = true;
        this.requestComboTipoDocumentos.filter = query;
        axios
            .get(appConfig.recursosApi.tipoDocumento,{params: this.requestComboOrganismos  })
            .then((response) => {
                this.listadoTipoDocumentos = response.data.result;                
                this.isLoadingComboTipoDocumentos = false;
                return this.data
            })
             .catch(()=>  {
               this.listadoTipoDocumentos = [];
               this.isLoadingComboTipoDocumentos = false;
               // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                this.$router.push('/500') ;                
            }); 
    },
    waitForValidation () {
    return new Promise((resolve) => {
      const unwatch = this.$watch(() => !this.$v.$pending, (isNotPending) => {
        if (isNotPending) {
          unwatch()
          resolve(!this.$v.$invalid)
        }
      }, {immediate: true})
    })},     
    handleSubmit(e) {
       this.cargarListado();
     
    },
    descargarArchivo(idD){
        let promise =  axios
            .get(appConfig.recursosApi.archivo,{id: idD  });
            return promise.then((response) => {
                this.data.archivoDesc = response.data.result;                
                var archiv= 'data:application/octet-stream;base64,'+this.data.archivoDesc.file;
                return archiv;
            })
             .catch(()=>  {
               this.isBusy = false;
               // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                this.$router.push('/500') ;
                return [];
            }); 
     },
},   
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
 <div class="row">
      <div class="col-lg-12">
        <div class="card-box">
          <h4 class="header-title m-t-0">Consulta Documentos</h4>
          <p class="text-muted font-14 m-b-20" ></p>
           <form @submit.prevent="handleSubmit">
              <!-- Organismo y Rol -->
            <div class="form-row"> 
                <div class="form-group col-md-6">
                    <label for="organismo">Organismo </label>
                        <multiselect id="organismo" v-model="organismoSeleccionado"  
                            label="nombre" 
                            track-by="id" 
                            placeholder="Teclea el nombre del organismo" 
                            open-direction="bottom" 
                            deselect-label=" X "
                            select-label=" + "
                            selected-label=" Seleccionado"
                            :options="listadoOrganismos" 
                            :multiple="false" 
                            :searchable="true" 
                            :loading="isLoadingCombo" 
                            :internal-search="false" 
                            :clear-on-select="false" 
                            :close-on-select="true" 
                            :options-limit="100" 
                            :limit="3" 
                            :max-height="500" 
                            :show-no-results="true" 
                            :hide-selected="false"
                            @search-change="loadOrganismos" >
                            <span slot="noResult">No se encontraron resultados.</span>
                            <span slot="noOptions">No se encontraron organismos.</span>
                          </multiselect>
                </div>
                <div class="form-group col-md-6">
                    <label for="tipoDocumento">Tipo Documento </label>
                        <multiselect id="tipoDocumento" v-model="tipoDocumentoSeleccion"  
                            label="descripcion" 
                            track-by="id" 
                            placeholder="Teclea el nombre del tipo documento." 
                            open-direction="bottom" 
                            deselect-label=" X "
                            select-label=" + "
                            selected-label=" Seleccionado"
                            :options="listadoTipoDocumentos" 
                            :multiple="false" 
                            :searchable="true" 
                            :loading="isLoadingComboTipoDocumentos" 
                            :internal-search="false" 
                            :clear-on-select="false" 
                            :close-on-select="true" 
                            :options-limit="100" 
                            :limit="3"                             
                            :max-height="500" 
                            :show-no-results="true" 
                            :hide-selected="false"
                            @select="tipoDocumentoSeleccionado"
                            @search-change="loadTiposDocumentos" >
                            <span slot="noResult">No se encontraron resultados.</span>
                            <span slot="noOptions">No se encontraron tipos documentos.</span>
                            </multiselect>
                        </div>
            </div>
             <div class="form-row"> 
                  <div class="form-group col-md-4">
                    <label for="name">
                     Nombre del documento
                        <span class="text-danger">*</span>
                    </label>
                     <input
                        id="nombre"
                        v-model="nombreDocumento"
                        name="nombre"
                        class="form-control"
                      
                        type="text"
                        placeholder="" />
                </div>
                <div v-for="(item, index) in listaValoresMetadatos" :key="item.idMetadato" class="form-group col-md-4">
                    <label for="name">
                      {{ item.descripcion }}
                    </label>
                     <input v-if="item.tipo === 'String'"
                        :key="index"
                        v-model="listaValoresMetadatos[index].valor"
                        class="form-control"
                        type="text"
                        placeholder=""
                    />
                    <date-picker v-else-if="item.tipo === 'Fecha'" 
                        v-model="listaValoresMetadatos[index].valor"
                        :first-day-of-week="1" 
                        format="DD/MM/YY"
                        lang="es"></date-picker>
                    <multiselect  v-else-if="item.tipo === 'Lista'" 
                     v-model="listaValoresMetadatos[index].valor"
                    label="descripcion" 
                    track-by="valor"
                    placeholder="" 
                     deselect-label=" X "
                    select-label=" + "
                    selected-label=" Seleccionado" 
                    :options="listaValoresMetadatos[index].listado">
                    <span slot="noResult">No se encontraron resultados.</span>
                    <span slot="noOptions">No se encontraron valores.</span>
                    </multiselect>
                </div>
            </div>
            <div class="form-group text-right m-b-0">
              <button class="btn btn-primary" type="submit" :disabled="isBusy">   <b-spinner v-show="isBusy"  small></b-spinner> <i  v-show="!isBusy"  class="fas fa-search"></i> Buscar</button>
            </div>
           </form>
        </div>
        <!-- end card-box -->
      </div>
 </div>


 <div class="row">
      <div class="col-lg-12">
        <div class="card-box">
          <h4 class="header-title m-t-0">Documentos</h4>
          <p class="text-muted font-14 m-b-20"></p>
           <div class="row mb-md-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select> &nbsp; &nbsp; registros
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
              :busy.sync="isBusy"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :items="listaDocumentos"
              :fields="fields"
              responsive="sm"
              >
              <template v-slot:table-busy>
                 <div class="text-center text-success ">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Cargando...</strong>
                </div>
              </template>
              <template v-slot:cell(idDocumento)="row">
                <router-link class="btn btn-secondary m-l-5 ml-1 btn-xs btn-rounded" :to="{ name: 'editar_documento',params: { id: row.value } }"> <i class="fe-edit"></i> Editar</router-link>
                <b-button href="#" variant="btn btn-info m-l-5 ml-1 btn-xs btn-rounded"  @click="descargarArchivo(row.value)" ><i class="dripicons-cloud-download"></i></b-button>
        
               </template>
              </b-table>
            </div>
             <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                align="fill"
                                size="sm"
                                class="my-0">
                            </b-pagination>
                  </ul>
                </div>
              </div>
            </div>
        </div>
        <!-- end card-box -->
      </div>
 </div>
  </Layout>
</template>